import * as React from 'react';

const TradingViewIcon = (props: { className: string }) => {
    return (
        <svg className={props.className} aria-hidden="true" viewBox="0 0 36 28" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 22H7V11H0V4h14v18zM28 22h-8l7.5-18h8L28 22z" fill="currentColor"></path>
            <circle cx="20" cy="8" r="4" fill="currentColor"></circle>
        </svg>
    );
};

export default TradingViewIcon;
